import { Button, FormControl, FormLabel, Heading, Text, Textarea } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { LoadingBlock } from '../../../components/Loading'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'
import { useAppToast } from '../../../helpers'
import BrilhaMagentaService from '../../../services/BrilhaMagenta/BrilhaMagentaService'

interface IQuestion {
  id: number
  title: string
  type: string
}

export default function BrilhaMagentaEmployeeNotePage() {
  const toast = useAppToast()
  const brilhaMagentaService = new BrilhaMagentaService()
  const uuid = useParams().uuid as string

  const [loading, setLoading] = useState<boolean>(true)
  const [notFound, setNotFound] = useState<boolean>(false)
  const [employeeName, setEmployeeName] = useState<string>('')
  const [question, setQuestion] = useState<IQuestion | null>(null)
  const [answer, setAnswer] = useState<string>('')
  const [saving, setSaving] = useState<boolean>(false)
  const [saved, setSaved] = useState<boolean>(false)

  useEffect(() => {
    if (!uuid) {
      setNotFound(true)
      setLoading(false)
      return
    }

    brilhaMagentaService
      .getEmployeeNote(uuid)
      .then((response) => {
        setEmployeeName(response.data.employee_name)
        setQuestion(response.data.question)
        setAnswer(response.data.answer ?? '')
      })
      .catch(() => {
        setNotFound(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [uuid])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSaving(true)

    try {
      await brilhaMagentaService.saveEmployeeNote(uuid, answer)
      setSaved(true)
      toast.success('Nota enviada com sucesso!')
    } catch {
      toast.error('Erro ao enviar a nota', 'Tente novamente mais tarde.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <PublicFormLayout title="Brilha Magenta">
      {loading && <LoadingBlock size="page" />}

      {!loading && notFound && (
        <Heading as="h2" textAlign="center">
          Registro não encontrado.
        </Heading>
      )}

      {!loading && !notFound && question && (
        <form onSubmit={handleSubmit}>
          <Heading as="h2" mb="4">
            Nota do liderado(a)
          </Heading>
          <Text mb="4">
            Olá, {employeeName}! Se quiser, registre abaixo a sua percepção sobre os pontos abordados no feedback. É
            opcional.
          </Text>
          {saved && (
            <Text mb="4" color="green.500" fontWeight="semibold">
              Sua nota foi enviada! Você pode alterá-la e enviar novamente, se quiser.
            </Text>
          )}
          <FormControl isRequired mb="4">
            <FormLabel>{question.title}</FormLabel>
            <Textarea value={answer} onChange={(event) => setAnswer(event.target.value)} height="180px" />
          </FormControl>
          <Button colorScheme="magenta" type="submit" isLoading={saving}>
            {saved ? 'Atualizar nota' : 'Enviar nota'}
          </Button>
        </form>
      )}
    </PublicFormLayout>
  )
}
